/*
 * rd-cart-timer.js
 *
 * Arranca el temporizador del carrito ("Carrito reservado por 05:00").
 *
 * El elemento <countdown-timer> SÍ existe en secondary.js, pero su constructor
 * solo arranca el reloj si el elemento trae data-auto-play="true":
 *
 *     "true" === this.dataset.autoPlay && this.playTimer();
 *
 * Y el marcado del carrito solo pone data-duration, nunca data-auto-play.
 * Quien llamaba a playTimer() era el main.js externo, que ya no funciona.
 * Por eso el reloj se dibujaba pero se quedaba congelado.
 *
 * Además, el JS de Dawn reemplaza el HTML del drawer en cada cambio del
 * carrito, así que el <countdown-timer> se destruye y se vuelve a crear:
 * hay que rearrancarlo en cada repintado, no solo al cargar la página.
 */
(function () {
  'use strict';

  function startTimers(root) {
    var scope = root || document;

    scope.querySelectorAll('countdown-timer').forEach(function (timer) {
      // playTimer() ya se protege solo contra arranques dobles (this.isPlaying),
      // pero comprobamos que el elemento esté "actualizado" (upgraded) y que
      // el método exista, por si secondary.js aún no ha cargado.
      if (typeof timer.playTimer !== 'function') return;
      timer.playTimer();
    });
  }

  function init() {
    startTimers();

    var section = document.getElementById('shopify-section-cart-drawer');
    if (!section) return;

    // Cada vez que Dawn repinta el drawer, el timer es un elemento NUEVO.
    var observer = new MutationObserver(function (mutations) {
      var recreated = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return (
            node.tagName === 'COUNTDOWN-TIMER' ||
            (node.querySelector && node.querySelector('countdown-timer'))
          );
        });
      });

      if (recreated) startTimers(section);
    });

    observer.observe(section, { childList: true, subtree: true });
  }

  // Los custom elements se definen en scripts diferidos: esperamos a que el
  // DOM esté listo para que <countdown-timer> ya tenga sus métodos.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
